module.exports = __webpack_public_path__ + "static/intlepos@2x-ff069d40d0cfee4509070602a65a54e1.png";